import { useId, useState } from 'react';
import { AGENDA_END_HOUR, AGENDA_START_HOUR, AGENDA_TOTAL_MINUTES } from '../agendaConfig';
import type { ChainBlockedInterval } from '../chainIntraDayConstraints';

export function AgendaChainBlockedInterval({ interval }: { interval: ChainBlockedInterval }) {
  const id = useId();
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const start = Math.max(AGENDA_START_HOUR * 60, interval.startMinute);
  const end = Math.min(AGENDA_END_HOUR * 60, interval.startMinute + interval.duration);
  if (end <= start) return null;
  const explanation = 'Zu dieser Uhrzeit nicht verfügbar';
  return (
    <div className="agenda-chain-placement__blocked-interval" role="group" tabIndex={0}
      aria-disabled="true" aria-label={explanation} aria-describedby={hovered || focused ? id : undefined}
      data-start-minute={interval.startMinute} data-duration={interval.duration}
      onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
      onKeyDown={(event) => {
        if (event.key === 'Escape' && (hovered || focused)) {
          event.preventDefault(); event.stopPropagation(); setHovered(false); setFocused(false);
        }
      }}
      style={{ top: `${(start - AGENDA_START_HOUR * 60) / AGENDA_TOTAL_MINUTES * 100}%`, height: `${(end - start) / AGENDA_TOTAL_MINUTES * 100}%` }}>
      {hovered || focused ? <span id={id} role="tooltip" className="agenda-chain-placement__tooltip">{explanation}</span> : null}
    </div>
  );
}
